import { useRef, useEffect } from 'react';

export const useThrottleEffect = (
  effect: () => void | (() => void), // функция эффекта
  dependencies: any[],               // массив зависимостей
  limit: number = 1000              // интервал throttling в миллисекундах
) => {
  const lastRun = useRef(0);
  const timeout = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    const now = Date.now();

    if (now - lastRun.current >= limit) {
      effect();
      lastRun.current = now;
    } else {
      if (timeout.current) {
        clearTimeout(timeout.current);
      }
      timeout.current = setTimeout(() => {
        effect();
        lastRun.current = Date.now();
      }, limit - (now - lastRun.current));
    }

    return () => {
      if (timeout.current) {
        clearTimeout(timeout.current);
      }
    };
    // eslint-disable-next-line
  }, dependencies);
}
